<div class="page__wrapper">
  <div class="header">
    <a class="logo-link" [routerLink]="'/'">
      <img class="logo" src="/assets/images/svg/rebrand/logo-full.svg" alt="Logo" />
    </a>
  </div>
  <div class="page page-error">
    <div class="flex flex-col justify-center items-center">
      <div class="error-content text-center inverted-colors">
        <img
          src="/assets/images/rebrand/not-found/404.png"
          srcset="/assets/images/rebrand/not-found/404@2x.png 2x, /assets/images/rebrand/not-found/404@3x.png 3x"
          alt="404"
          class="error__image"
        />
        <h2 class="mt-60">{{ 'SHARED.CONTAINERS.NOT_FOUND.TITLE' | translate }}</h2>
        <p class="text-xl mt-10 mb-60">{{ 'SHARED.CONTAINERS.NOT_FOUND.SUB_TITLE' | translate }}</p>
        <button class="btn btn-lg" (click)="goHome()">
          {{ 'SHARED.CONTAINERS.NOT_FOUND.CTA_TEXT' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
